export const services = [
  {
    icon: "bi-building-gear",
    title: "ERP Application Development",
    short: "Accounting, inventory, HR, payroll, GST, sales and reports in one secure system.",
    details: ["Custom modules", "Role-based login", "Dashboard & reports", "GST-ready workflows"]
  },
  {
    icon: "bi-graph-up-arrow",
    title: "SEO Services",
    short: "Technical SEO, content structure, speed optimization and ranking improvement.",
    details: ["On-page SEO", "Schema setup", "Speed improvement", "Search Console guidance"]
  },
  {
    icon: "bi-globe2",
    title: "Domain Name Registration",
    short: "Business domain, DNS, SSL, email and brand identity setup.",
    details: ["Domain search", "DNS setup", "SSL configuration", "Business email"]
  },
  {
    icon: "bi-server",
    title: "Servers & Hosting",
    short: "VPS, cloud hosting, deployment, backup, monitoring and security hardening.",
    details: ["Windows/Linux servers", "IIS hosting", "Backup setup", "Uptime monitoring"]
  },
  {
    icon: "bi-megaphone",
    title: "Social Media Ads",
    short: "Professional ad campaigns for brand awareness, leads and customer growth.",
    details: ["Meta ads", "Google ads", "Creative design", "Lead generation"]
  },
  {
    icon: "bi-code-slash",
    title: "Website & API Development",
    short: "Modern React websites, ASP.NET Core APIs, SQL Server databases and integrations.",
    details: ["React UI", "ASP.NET Core API", "SQL Server", "Payment/API integrations"]
  }
];

export const testimonials = [
  { name: "Retail Business", text: "The ERP workflow helped us manage sales, stock, accounts and reports in a professional way." },
  { name: "Service Company", text: "Our website and SEO setup became faster, cleaner and more business-focused." },
  { name: "Startup Team", text: "Server deployment, domain, SSL and business email were handled smoothly." }
];
